import React from "react"

interface ColorDisplayProps {
  colorCode: string
}

const ColorDisplay: React.FC<ColorDisplayProps> = ({ colorCode }) => {
  const boxStyle: React.CSSProperties = {
    width: "20px",
    height: "20px",
    backgroundColor: colorCode,
    display: "inline-block",
    marginRight: "5px",
    border: "1px solid #ccc",
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={boxStyle}></div>
      <span>{colorCode}</span>
    </div>
  )
}

export default ColorDisplay
